import styled from "@emotion/styled";
import * as React from "react";
import { match } from "ts-pattern";
import PinKey, { PinKeyValue } from "./PinKey";

export interface Props {
  value: string;
  onChange: (pin: string) => void;
}

const PinKeyboard = (props: Props) => {
  const handleClick = (key: PinKeyValue) => {
    return match(key)
      .with("backspace", () => props.onChange(props.value.slice(0, -1)))
      .otherwise(() => props.onChange(props.value + key));
  };

  return (
    <PinKeyboard.Root>
      <PinKey value="1" onClick={handleClick} />
      <PinKey value="2" onClick={handleClick} />
      <PinKey value="3" onClick={handleClick} />
      <PinKey value="4" onClick={handleClick} />
      <PinKey value="5" onClick={handleClick} />
      <PinKey value="6" onClick={handleClick} />
      <PinKey value="7" onClick={handleClick} />
      <PinKey value="8" onClick={handleClick} />
      <PinKey value="9" onClick={handleClick} />
      <div />
      <PinKey value="0" onClick={handleClick} />
      <PinKey value="backspace" onClick={handleClick} />
    </PinKeyboard.Root>
  );
};

PinKeyboard.Root = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-rows: 1fr 1fr 1fr 1fr;
  justify-items: center;
  gap: 12px;
`;

export default PinKeyboard;
